import * as React from 'react';
import styled from 'styled-components';

import { Box } from '@packages/ui';
import { ModuleRow } from '@packages/common';

import { moduleMargin } from '../utils';
import { gutterParent, gutter } from './Grid.util';

const Container = styled.div`
  ${moduleMargin};
`;

const Column = styled(Box)<{ gutter: number[] }>`
  ${gutter}
  & {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const RowContainer = styled.div<any>`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  ${gutterParent};
  & {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export type RowProps = ModuleRow & {
  moduleComponent: React.ElementType;
};

const GUTTER = [2, 2, 3];
const CHILD_GUTTER = [8, 8, 16];

export const Row: React.FC<RowProps> = ({ modules, columns, moduleComponent: ModuleComponent }) => (
  <Container>
    <RowContainer gutter={GUTTER}>
      {modules.map((module, index) => (
        <Column key={module.id} width={columns[index]} gutter={CHILD_GUTTER}>
          <ModuleComponent {...module} />
        </Column>
      ))}
    </RowContainer>
  </Container>
);
